import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Organization from "pages/Organization"
import OrganizationList from "pages/Organization/List";
import UsersList from "pages/Organization/UsersList"
import FactoryList from "pages/Factory/List";
import FactoryDetails from "pages/Factory/Details";
import DailyMonitoringMonthlyReport from "../pages/DailyMonitoring/MonthlyReport";
import DailyMonitoringDailyReport from "../pages/DailyMonitoring/DailyReport";
import DailyMonitoringReport from "../pages/DailyMonitoring/Report";
import MonthlyMonitoringReport from "../pages/MonthlyMonitoring";
import PerformanceReport from "../pages/MonthlyMonitoring/PerformanceReport";
import DailyWorkReport from "../pages/DailyWorkReport";
import PerformaceScore from "../pages/PerformaceScore";
import StatutoryReport from '../pages/statutoryReport'
import DailyDocumentReview from '../pages/DailyDocumentReview'
import HealthAndSaftyReport from '../pages/HealthAndSafety'
import PerformanceReview from "pages/PerformanceReview"
import TasksAssigned from "../pages/TasksAssigned"

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },

  // //profile
  { path: "/profile", component: UserProfile },

  { path: "/orgs", component: Organization },
  { path: "/orgs/list", component: OrganizationList },
  { path: "/orgs/list/:orgId/users", component: UsersList },
  { path: "/orgs/list/:orgId/factory/list", component: FactoryList },
  { path: "/orgs/list/:orgId/factory/:facId", component: FactoryDetails },
  { path: '/daily-monitoring', component: DailyMonitoringMonthlyReport, permission: 'Daily_onSiteInspection' },
  { path: '/daily-monitoring/:year/:month', component: DailyMonitoringDailyReport, permission: 'Daily_onSiteInspection' },
  { path: '/daily-monitoring/:year/:month/:day', component: DailyMonitoringReport, permission: 'Daily_onSiteInspection' },
  { path: '/monthly-monitoring', component: MonthlyMonitoringReport, permission: 'Monthly_work_report' },
  { path: '/monthly-monitoring/:year/:month', component: PerformanceReport, permission: 'Monthly_work_report' },
  { path: '/daily-document-review', component: DailyDocumentReview, permission: 'Daily_Document_Review' },
  { path: '/daily-work-report', component: DailyWorkReport, permission: 'Daily_work_report' },
  { path: '/performance-score', component: PerformaceScore, permission: 'Performance_Review' },
  { path: '/statutory-report', component: StatutoryReport, permission: 'Monthly_Document_Review' },
  { path: '/Health-Safety', component: HealthAndSaftyReport, permission: 'Monthly_onSiteInspection' },
  { path: '/monthly-monitoring/performanceReview', component: MonthlyMonitoringReport, permission: 'Monthly_work_report' },
  // Assign Tasks — visible to every factory user (no permission gate).
  { path: '/tasks-assigned', component: TasksAssigned },


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  // Public self-signup removed: only a super admin creates logins.
]

export { publicRoutes, authProtectedRoutes }
